module.exports = __webpack_public_path__ + "fonts/sourcesanspro.173382e6.ttf";